module.exports = __webpack_public_path__ + "static/media/background_980.560d5da7.png";